// Compact platform icon/pill — small footprint variant for tight spaces (e.g. drawer sidebar)
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faXTwitter,
  faInstagram,
  faReddit,
  faThreads,
  faFacebook,
  faPinterest,
  faQuora,
} from "@fortawesome/free-brands-svg-icons";

const PLATFORM_CONFIG = {
  ALL: { icon: faInfinity, color: "#7e5bef", bg: "#f3effe", label: "All" },
  FACEBOOK: { icon: faFacebook, color: "#4267B2", bg: "#E9F1FB", label: "Facebook" },
  TWITTER: { icon: faXTwitter, color: "#111111", bg: "#f1f1f1", label: "Twitter" },
  YOUTUBE: { icon: faYoutube, color: "#FF0000", bg: "#FFEBEB", label: "YouTube" },
  INSTAGRAM: { icon: faInstagram, color: "#E4405F", bg: "#FDECEF", label: "Instagram" },
  THREADS: { icon: faThreads, color: "#111111", bg: "#f1f1f1", label: "Threads" },
  REDDIT: { icon: faReddit, color: "#FF4500", bg: "#FFEDE5", label: "Reddit" },
  PINTEREST: { icon: faPinterest, color: "#E60023", bg: "#FFF0F0", label: "Pinterest" },
  QUORA: { icon: faQuora, color: "#B92B27", bg: "#FDECEA", label: "Quora" },
};

export const renderPlatformIconCompact = (platform) => {
  const key = (platform || "").toUpperCase();
  const cfg = PLATFORM_CONFIG[key] || {
    icon: null,
    color: "#64748b",
    bg: "#f1f5f9",
    label: platform || "Unknown",
  };

  return (
    <span
      title={cfg.label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "3px 8px 3px 6px",
        borderRadius: "999px",
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontFamily: "'Host Grotesk', sans-serif",
        fontSize: "0.7rem",
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
      }}
    >
      {cfg.icon && (
        <FontAwesomeIcon icon={cfg.icon} style={{ fontSize: "10px" }} />
      )}
      {cfg.label}
    </span>
  );
};
